import { navigateTo } from 'nuxt/app'

const TRAILING_SLASHES_RE = /\/+$/

export default defineNuxtRouteMiddleware((to) => {
  if (to.path.includes('preview')) {
    return
  }

  const normalizedPath = to.path === '/' ? '/' : `${to.path.replace(TRAILING_SLASHES_RE, '')}/`

  if (to.path !== normalizedPath) {
    let redirectCode = 301

    if (normalizedPath === '/de/' || normalizedPath === '/fr/') {
      redirectCode = 302
    }

    return navigateTo({ path: normalizedPath, query: to.query }, { redirectCode })
  }
})
